




import { Component, Prop, Vue } from 'vue-property-decorator';
import { pageClicked } from '@utils/analytics';

@Component
export default class BaseLinkButton extends Vue {
	@Prop()
	private classes!: string;

	@Prop()
	private clickText?: string;

	handleTracking($event: Event): void {
		const slot = this.$slots?.default ?? undefined;
		const clickText = this.clickText;
		pageClicked({ slot, clickText });
		this.$emit('click', $event);
	}
}
